import { useQueryWithError } from "@ssf/components";
import { getMembers } from "@ssf/memdb-api";
import { useEffect, useState } from "react";
export const queryDupe = (query) => getMembers({
    query,
    firstname_count: 1,
    lastname_birthday_count: 2,
    schema: {
        id: 1,
        firstname: 1,
        lastname: 1,
        street: 1,
        zipcode: 1,
        city: 1,
    },
});
export const useQueryDupe = (query, options) => useQueryWithError(["useQueryDupe", query], () => queryDupe(query), options);
export const useDupe = (query, enabled) => {
    const [showDialog, setDialog] = useState(false);
    const toggleDialog = () => setDialog(!showDialog);
    const { data: dupes } = useQueryDupe(query, { enabled });
    useEffect(() => {
        if (dupes?.length) {
            setDialog(true);
        }
    }, [dupes]);
    return { dupes, showDialog, toggleDialog };
};
//# sourceMappingURL=useDupe.js.map